// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Patient } from '@medplum/fhirtypes';

export type PatientTabBadgeCounts = Partial<Record<string, number>>;

/**
 * Returns a map from patient-chart tab `id` to a numeric badge count. The
 * `PatientTabsNavigation` component reads this to render a red circular badge
 * next to a tab label (e.g., a `1` on the Profile tab when there's an
 * outstanding balance).
 *
 * Common PR stub: returns an empty map — each follow-up tab PR populates its
 * own entry. Keeping the hook in place now means later PRs do not need to
 * touch `PatientTabsNavigation` to wire counts in.
 */
export function usePatientTabBadges(_patient: Patient | undefined): PatientTabBadgeCounts {
  return {};
}
